"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Toast;
const React = __importStar(require("react"));
const styles_1 = require("./styles");
const building_blocks_ui_theme_1 = require("@acko-tech/building-blocks.ui.theme");
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
function Toast(props) {
    const { timeout = 3000 } = props;
    const [toastVisible, setToastVisible] = React.useState(true);
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    React.useEffect(() => {
        props.toastMessage && setToastVisible(true);
        setTimeout(() => {
            setToastVisible(false);
        }, timeout);
    }, [props.toastMessage]);
    return (React.createElement(React.Fragment, null, toastVisible && props.toastMessage ? (React.createElement(building_blocks_ui_theme_1.ThemeProvider, { theme: building_blocks_ui_theme_1.AckoMainTheme },
        React.createElement(building_blocks_ui_common_1.Flex, { justifyContent: "center" },
            React.createElement(styles_1.ToastWrapper, { theme: theme, colors: colors },
                React.createElement(building_blocks_ui_common_1.Flex, { alignItems: "center" },
                    props.toastType && (React.createElement(styles_1.ImageContainer, { theme: theme, colors: colors, onClick: () => setToastVisible(false) },
                        props.toastType === 'error' && (React.createElement(styles_1.CancelRedComponent, { src: "https://central-frontend-prod.ackoassets.com/_next_static/images/building-block-assets/cancel-red.svg" })),
                        props.toastType === 'success' && (React.createElement(styles_1.CheckGreenComponent, { src: "https://central-frontend-prod.ackoassets.com/_next_static/images/building-block-assets/check-green.svg" })),
                        props.toastType === 'info' && (React.createElement(styles_1.InfoWhiteComponent, { src: "https://central-frontend-prod.ackoassets.com/_next_static/images/building-block-assets/info-white.svg" })))),
                    React.createElement(styles_1.Message, { theme: theme, colors: colors }, props.toastMessage)))))) : null));
}
//# sourceMappingURL=toast.js.map